import { render, staticRenderFns } from "./user_header.vue?vue&type=template&id=1fde740a"
import script from "./user_header.vue?vue&type=script&lang=js"
export * from "./user_header.vue?vue&type=script&lang=js"
import style0 from "./user_header.vue?vue&type=style&index=0&id=1fde740a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports